import { Box, Stack, Typography } from '@mui/material'
import { useState } from 'react'

import { Copy } from '@phosphor-icons/react'
import { UnauthenticatedActionTooltip } from 'ui-components/components/molecules/UnauthenticatedActionTooltip'

type DuplicateMapProps = {
  authenticated: boolean
  onClick: () => void
  onSignInClick: () => void
}

export function DuplicateMapButton(props: DuplicateMapProps) {
  const [anchorEl, setAnchorEl] = useState(null)
  const handleClick = (event) => {
    if (!props.authenticated) {
      setAnchorEl(event.currentTarget)
      return
    }
    props.onClick()
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <UnauthenticatedActionTooltip
        primary='Want to save this map for later?'
        secondary='Sign in to get started'
        anchorEl={anchorEl}
        onClose={handleClose}
        onSignInClick={props.onSignInClick}
      />
      <Stack
        alignItems='center'
        spacing={1}
        onClick={handleClick}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 50,
            height: 50,
            border: '1px solid #c3c3c3',
            borderRadius: 1,
            cursor: 'pointer',
            transition: 'background 0.2s',
            '&:hover': {
              background: '#f5f5f5'
            }
          }}
        >
          <Copy fontSize={26} />
        </Box>
        <Typography variant='body2'>Copy map</Typography>
      </Stack>
    </>
  )
}
